/**
 * A draw region: an element where the real cursor is hidden and the draw
 * cursor shows, in the ink colour the region carries. Surfaces mark their
 * drawing area while the pen is active; the lock marks its overlay. The
 * lookup walks ancestors, since a surface may mark a container.
 */
export const SHIELD_ATTR = "data-drawlock-shield";
export const INK_ATTR = "data-drawlock-ink";

export function markDrawRegion(el: HTMLElement, ink: string): void {
  el.setAttribute(SHIELD_ATTR, "");
  el.setAttribute(INK_ATTR, ink);
  el.style.cursor = "none";
}

export function unmarkDrawRegion(el: HTMLElement): void {
  el.removeAttribute(SHIELD_ATTR);
  el.removeAttribute(INK_ATTR);
  el.style.cursor = "";
}

/** The marked region the pointer is in, or null. */
export function drawRegionAt(target: EventTarget | null): HTMLElement | null {
  return target instanceof Element
    ? target.closest<HTMLElement>(`[${SHIELD_ATTR}]`)
    : null;
}

/** The region under a point, for re-reads under a still pointer. */
export function drawRegionAtPoint(x: number, y: number): HTMLElement | null {
  return drawRegionAt(document.elementFromPoint(x, y));
}
